<template>
  <div>
    <v-btn
      :loading="loading"
      class="mx-2"
      fab
      dark
      small
      color="primary"
      @click="loadMenages()"
    >
      <v-icon dark>
        mdi-cached
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menages: [],
      loading: false,
    };
  },
  props: {
    region: {
      required: true,
    },
  },

  methods: {
    loadMenages() {
      let self = this;
      self.loading = true;
      self.$firebase
        .firestore()
        .collection("newMenages")
        .where("id_region", "in", [
          self.region.id.toString(),
          parseInt(self.region.id),
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var menage = doc.data();
            menage.id = doc.id;
            self.menages.push(menage);
          });
          self.loading = false;
          self.updateRegion(self.menages.length);
          self.$emit("updateRegion");
        });
    },

    updateRegion(nombre) {
      let self = this;
      var ref = self.$firebase
        .firestore()
        .collection("regions")
        .doc(self.region.id);

      ref.set(
        {
          nbreMenage: nombre,
          dateStatMenage: self.$moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        { merge: true }
      );
    },
  },
};
</script>

<style scoped></style>
